import { IBanner } from '../utils/entities/interface';
import { post, get, del } from './https';

const fetchBanners = async (): Promise<IBanner[]> => {
  const response = await get('/api/v1/admin/home-banner/list');
  if (response.status == 200 && Array.isArray(response.data?.data)) {
    return response.data.data;
  } else {
    throw Error('Error while Fetching Banners');
  }
};

// Mirrors the backend HomeBanner model's required/optional fields exactly -
// see IBanner in utils/entities/interface.ts. appType/mediaType/mediaUrl were
// previously missing here (and the field was called imageUrl instead of
// mediaUrl), so every save from the admin UI was rejected by the backend's
// required-fields check.
const saveBanner = async (
  banner: Partial<{
    appType: string;
    mediaType: string;
    mediaUrl: string;
    thumbnailUrl: string;
    section: string;
    order: number;
    destination: string;
    position: number;
    data: string;
  }>,
): Promise<number> => {
  const response = await post('/api/v1/admin/home-banner/create', banner);
  if (response.status == 201) {
    return 201;
  } else {
    throw Error('Failed while Uploading new banner');
  }
};

const editBanner = async ({
  id,
  appType,
  mediaType,
  mediaUrl,
  thumbnailUrl,
  section,
  order,
  destination,
  position,
  data,
}: {
  id: string;
  appType: string;
  mediaType: string;
  mediaUrl: string;
  thumbnailUrl?: string;
  section?: string;
  order?: number;
  destination: string;
  position: number;
  data?: string;
}) => {
  const response = await post('/api/v1/admin/home-banner/edit', {
    id,
    appType,
    mediaType,
    mediaUrl,
    thumbnailUrl,
    section,
    order,
    destination,
    position,
    data,
  });
  if (response.status == 200) {
    return 200;
  } else {
    throw Error('Failed To Update Banner');
  }
};

const deleteBanner = async (bannerId: string): Promise<boolean> => {
  const response = await del(`/api/v1/admin/home-banner/delete/${bannerId}`);
  if (response.status) {
    return true;
  } else {
    throw Error('Failed To Delete Banner');
  }
};

export { saveBanner, fetchBanners, editBanner, deleteBanner };
